import { render, staticRenderFns } from "./FooterArea.vue?vue&type=template&id=6f8ef87d"
import script from "./FooterArea.vue?vue&type=script&lang=js"
export * from "./FooterArea.vue?vue&type=script&lang=js"
import style0 from "./FooterArea.vue?vue&type=style&index=0&id=6f8ef87d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports